// @flow weak
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import { CommonActions } from '@react-navigation/native';
import { PhonePicker } from '../../../components/dashboard';
import I18n from '../../../lib/i18n';
import { currentSubscriptionSelector, hasVisibleSubscriptionsSelector } from '../../../modules/Dashboard';
import { isSubscriptionVisible } from '../../../modules/Subscriptions';
import Navigation from '../../../lib/navigation';

const mapStateToProps = state => {
  const subscription = currentSubscriptionSelector(state);
  const { alias, number } =
    subscription && isSubscriptionVisible(subscription)
      ? subscription.line
      : { alias: I18n.t('Dashboard.LineSelector.yourOrders'), number: '' };

  return {
    alias,
    number,
    hasVisibleSubscriptions: hasVisibleSubscriptionsSelector(state),
  };
};

export default compose(
  connect(mapStateToProps),
  withProps({
    onPress: () => Navigation.dispatch(CommonActions.navigate({ name: 'lineSelector' })),
  })
)(PhonePicker);
